import { Link } from "react-router-dom";

export default function InvalidRoute() {
    return (
        <div className="min-h-screen bg-surface font-sans flex items-center justify-center px-4">
            <div className="text-center">
                <div className="text-[6rem] font-extrabold gradient-text mb-4">404</div>
                <h1 className="text-2xl font-bold text-on-surface mb-2">Page Not Found</h1>
                <p className="text-on-surface-variant mb-8">
                    The page you're looking for doesn't exist or has been moved.
                </p>
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 px-7 py-3 bg-primary text-on-primary rounded-full text-[0.9375rem] font-semibold shadow-1 hover:shadow-2 hover:brightness-[1.08] active:scale-[0.97] transition-all duration-200 ease-standard"
                >
                    <i className="fa-solid fa-arrow-left" /> Back Home
                </Link>
            </div>
        </div>
    );
}